import { render, staticRenderFns } from "./ReceiveForm.vue?vue&type=template&id=753c9bc0"
import script from "./ReceiveForm.vue?vue&type=script&lang=js"
export * from "./ReceiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports